import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { constants, UserRoles } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class NonAuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router, private cookieService:CookieService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let role = this.cookieService.get('role');
    let clientRoleTypes = [constants.userRoles.firmManager,constants.userRoles.projectManager,constants.userRoles.projectOwner];
    if (this.authService.isAuthenticated() && role === constants.userRoles.reviewer){
        this.router.navigateByUrl('/reviewer');
        return false;
    }
    if(this.authService.isAuthenticated() && clientRoleTypes.includes(role)){
        this.router.navigateByUrl('/client');
        return false;
    }
    // MP-5750: a signed-in client-portal user has one home, the Started project list.
    if (this.authService.isAuthenticated() && role === constants.userRoles.client) {
        this.router.navigateByUrl(constants.clientPortal.homeUrl);
        return false;
    }
    return true;
  }
}
